import { render, staticRenderFns } from "./AnnualSales.vue?vue&type=template&id=2c2b4ce9&scoped=true&"
import script from "./AnnualSales.vue?vue&type=script&lang=js&"
export * from "./AnnualSales.vue?vue&type=script&lang=js&"
import style0 from "./AnnualSales.vue?vue&type=style&index=0&id=2c2b4ce9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b4ce9",
  null
  
)

export default component.exports